
import MainCTASection from "./cta/MainCTASection";
import MainCTASection2 from "./cta/MainCTASection2";
import MainCTASection3 from "./cta/MainCTASection3";
import AuthorSection from "./cta/AuthorSection";
import NewContactSection from "./cta/NewContactSection";
import FaqSection from "./cta/FaqSection";
import ProfessionalPartnersSection from "./cta/ProfessionalPartnersSection";
import StoreAdvantagesSection from "./cta/StoreAdvantagesSection";

const CTASection = () => {
  return (
    <>
      <AuthorSection />
      <StoreAdvantagesSection />
      {/* 这里使用MainCTASection，您可以通过注释/取消注释来切换不同的CTA设计 */}
      <MainCTASection />
      {/* <MainCTASection2 /> */}
      {/* <MainCTASection3 /> */}
      <FaqSection />
      <NewContactSection />
      <ProfessionalPartnersSection />
    </>
  );
};

export default CTASection;
